import { GeofenceNotificationModel } from '@/_interfaces/GeofenceNotification'
import { commonService } from '../../_services'
const notificationService = commonService('api/v1/notifications')

const initialState = {
    all: { items: [], total: 0 },
    loading: false,
}

const deepCloneInitial = () => {
    return JSON.parse(JSON.stringify(initialState))
}

/* tslint:disable:variable-name */
export const notifications = {
    namespaced: true,
    state: deepCloneInitial,
    actions: {
        async getAll(context: any, params: any = {}): Promise<void> {
            context.commit('GET_ALL_REQUEST')

            return notificationService.getAll(params).then((resp) => {
                context.commit('GET_ALL_SUCCESS', resp)
            }).catch(errorMsg => {
                context.commit('GET_ALL_FAILURE')
                context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
            })
        },
        async readNotificaiton(context: any, data: any): Promise<void> {
            return notificationService.updateOne(data).then((resp) => {
                if (resp && resp.data?.success) {
                    context.commit('UPDATE_ITEM_SUCCESS', data)
                }
                return Promise.resolve(resp.data)
            }).catch(errorMsg => {
                context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
                return Promise.reject(errorMsg)
            })
        }
    },
    mutations: {
        GET_ALL_REQUEST(state: any) {
            state.loading = true
        },
        GET_ALL_SUCCESS(state: any, resp: { total: number, data: any[] }) {
            const { total, data } = resp

            /* tslint:disable-next-line */
            state.all = { items: data.map(item => item), total: (total || 0) }
            state.loading = false
        },
        GET_ALL_FAILURE(state: any) {
            state.all = { items: [], total: 0 }
            state.loading = false
        },
        UPDATE_REQUEST(state: any) {
            state.loading = true
        },
        UPDATE_ITEM_SUCCESS(state: any, item: any) {
            state.all.items = state.all.items.map((tmp: GeofenceNotificationModel) => {
                return tmp._id === item._id ? { ...tmp, operators_read: [item.reader_id] } : tmp
            })

            state.loading = false
        },
        REQUEST_ERROR(state: any) {
            state.loading = false
        },
        RESET_STATE(state: any) {
            Object.keys(initialState).forEach(key => {
                state[key] = initialState[key]
            })
        },
    },
    getters: {},
}
